<button
  type="button"
  class="button"
  [class.auto-height]="!defaultHeight"
  [class.outline]="outline"
  [class.short-padding]="shortPadding"
  [class.content-only]="contentOnly"
  [class.full-width]="fullWidth"
  [class.loading]="isLoading"
  [class.reverse]="reverse"
  [ngClass]="color"
  [disabled]="disabled"
  [appAutofocus]="autofocus"
  (click)="emitClick($event)"
>
  <ng-container *ngIf="isLoading">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading">
    <div *ngIf="iconName">
      <app-lucide-icon [iconName]="iconName"></app-lucide-icon>
    </div>

    <span
      *ngIf="text"
      class="text"
      [class.margin]="iconName"
      [class.reverse]="reverse"
      [class.full-width]="fullWidth"
    >{{ text }}</span>
  </ng-container>
</button>
